export function isWebRTCPTZEnabled(
  stream?: VideoStream,
  features?: StreamFeatures,
  isMobile?: boolean,
  isSmallScreen?: boolean,
  companyId?: string
): boolean {
  return Boolean((features?.ptz.active && features?.ptz.write) &&
    !isMobile &&
    stream?.ptz?.webRtc !== false &&
    !isSmallScreen &&
    stream?.sourceType === "EDGE"
  );
}
